import React from 'react';
import range from 'lodash/range';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/placeholderStyle';
import classnames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(styles);

const Placeholder = ({ items }: { items: number }) => {
	const classes = useStyles();
	return (
		<div className={classes.notificationPlaceholder}>
			{range(items).map((i) => (
				<span className={classnames(classes.notification, classes.placeholderGlow)} key={i}>
					<div className="topSection">
						<div>
							<span className={classnames(classes.placeholder, 'icon')}></span>
						</div>
						<div className="textWrapper">
							<span className={classnames(classes.placeholderGlow, classes.placeholderXs)}>
								<span className={classnames(classes.placeholder, classes.placeholderXs, 'col8')}></span>
							</span>
							<span className={classnames(classes.placeholderGlow, classes.placeholderXs)}>
								<span
									className={classnames(classes.placeholder, classes.placeholderXs, 'col12')}
								></span>
							</span>
						</div>
					</div>
					<div className="bottomSection">
						<span className={classnames(classes.placeholderGlow, classes.placeholderXs)}>
							<span className={classnames(classes.placeholder, classes.placeholderXs, 'col12')}></span>
							<span className={classnames(classes.placeholder, classes.placeholderXs, 'col12')}></span>
						</span>
					</div>
				</span>
			))}
		</div>
	);
};

export default Placeholder;
